import { ClassAttributes, LiHTMLAttributes, ReactNode, SyntheticEvent } from 'react'
import { TextField } from '@mui/material'
import MuiAutocomplete from '@mui/material/Autocomplete'
import InputLabel from '@mui/material/InputLabel'
import classNames from 'classnames'
import { t } from 'i18next'

import { AngleDownIcon2, LfCloseIcon } from 'src/components/shared/ui/Icons'
import { fieldsStyles as styles } from 'src/components/shared/ui/form/fields/fieldsStyles'

type Props = {
  id: string
  label: string
  value: any
  items: any[]
  itemName?: string
  itemKey?: string
  placeholder?: string
  disabled?: boolean
  renderOptionCallback?: (
    props: JSX.IntrinsicAttributes &
      ClassAttributes<HTMLLIElement> &
      LiHTMLAttributes<HTMLLIElement>,
    option
  ) => ReactNode
  getOptionLabelCallback?: (option: any) => string
  onChange: (event: SyntheticEvent<Element, Event>, newValue: any) => void
}
export default function AutoComplete(props: Props): JSX.Element {
  const {
    id,
    disabled,
    label,
    value,
    placeholder = '',
    items,
    onChange,
    itemName = 'name',
    itemKey = 'id',
    renderOptionCallback,
    getOptionLabelCallback
  } = props

  const autocompleteClassNames = classNames({
    disabled
  })

  function renderOption(
    props: JSX.IntrinsicAttributes &
      ClassAttributes<HTMLLIElement> &
      LiHTMLAttributes<HTMLLIElement>,
    option
  ) {
    if (renderOptionCallback) {
      return renderOptionCallback(props, option)
    }
    return (
      <li {...props} key={option[itemKey]}>
        {option[itemName]}
      </li>
    )
  }

  function getOptionLabel(option) {
    if (getOptionLabelCallback) {
      return getOptionLabelCallback(option)
    }
    return option[itemName]
  }

  return (
    <>
      <InputLabel id={`${id}-label`} className={autocompleteClassNames}>
        {label}
      </InputLabel>
      <MuiAutocomplete
        autoSelect
        disabled={disabled}
        id={id}
        value={value}
        options={items}
        popupIcon={<AngleDownIcon2 id={`${id}-icon`} sx={{ fontSize: '22px' }} />}
        clearIcon={<LfCloseIcon sx={{ fontSize: '16px' }} />}
        renderInput={params => (
          <TextField {...params} value={value} label="" placeholder={placeholder} />
        )}
        getOptionLabel={getOptionLabel}
        onChange={onChange}
        className={autocompleteClassNames}
        clearText={t('actions.clean')}
        closeText={t('actions.close')}
        loadingText={t('actions.loading')}
        noOptionsText={t('actions.no_options')}
        openText={t('actions.open')}
        sx={styles.input}
        renderOption={renderOption}
      />
    </>
  )
}
